import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  obtenerEspecialidadesMedicas: ["payload"],
  obtenerEspecialidadesMedicasLoading: null,
  obtenerEspecialidadesMedicasSuccess: ["obtenerEspecialidadesMedicasData"],
  obtenerEspecialidadesMedicasFailure: ["obtenerEspecialidadesMedicasError"],
});

export { Types };

export default Creators;

